import Vue from 'vue';
import { reactive, defineComponent } from '@vue/composition-api';
import { _rating_data } from './rating_data';
import { localName, post } from "../base/utils";
import preloader from "../components/preloader.vue";
import linker from "../components/linker.vue";
localName.value = "edimkytim";
export default defineComponent({
    name: "rating",
    components: { preloader: preloader, linker: linker },
    setup: function () {
        var data = reactive(_rating_data);
        //load data
        var loadData = function (loaded) {
            post('get_rating/', {}, function (d) {
                //console.log('data:', d);
                /*for (const key of Object.keys(r.data.result)) {
                  Vue.set(data, key, r.data.result[key]);}*/
                //console.log(loaded);
                Vue.set(data, 'collages', d.rating);
                loaded.value++;
            });
        };
        return {
            data: data,
            loadData: loadData,
        };
    },
});
